import { useState } from 'react';
import { Grid, Typography } from '@mui/material';

import TaskCard from 'components/TaskCard';
import TaskCardSkeleton from 'components/TaskCard/TaskCardSkeleton';
import { FilterMenu } from 'components/MyTasks';
import { Title, SETTING_UP_TASKS_MESSAGE, TASKS_SETUP_FAILED_MESSAGE } from 'components/Dashboard/MyTasks/styles';
import DefaultWrapper from 'shared-components/DefaultWrapper';
import useMyTasks from 'hooks/MyTasks';
import { Row } from './styles';

const options = [
  { key: 'all', value: 'All' },
  { key: 'incomplete', value: 'To do' },
  { key: 'in_progress', value: 'In progress' },
  { key: 'completed', value: 'Completed' },
];

const SkeletonWithGrid = () => (
  <Grid
    item
    md={6}
    lg={3}
    sx={{
      flex      : 1,
      marginTop : { xs: 2, sm: 0 },
      marginX   : { xs: 0.5, sm: 0 },
    }}>
    <TaskCardSkeleton />
  </Grid>
);

const MyTasks = () => {
  const [status, setStatus] = useState(options[0].key);
  const {
    participantTaskIds,
    numberOfTasks,
    isLoading,
    isSettingUpTasks,
    didTasksSetupFail,
    refetchProfileParticipantTasks,
  } = useMyTasks({
    ...(status !== 'all' ? { status } : {}),
  });

  const handleStatusChange = (taskStatus) =>
  {
    refetchProfileParticipantTasks({ status: taskStatus });
    setStatus(taskStatus);
  };

  const selectedFilterOption = options.find((option) => option.key === status);
  const content = isSettingUpTasks
    ? (
      <Title
        variant='h6'>
        {SETTING_UP_TASKS_MESSAGE}
      </Title>
    )
    : isLoading
    ? (
      <>
        <SkeletonWithGrid />
        <SkeletonWithGrid />
        <SkeletonWithGrid />
        <SkeletonWithGrid />
        <SkeletonWithGrid />
      </>
    )
    : numberOfTasks === 0
      ? (
        <Title
          variant='h6'>
          {didTasksSetupFail && status === 'all'
            ? TASKS_SETUP_FAILED_MESSAGE
            : 'There are no tasks available. Kindly check back later.'}
        </Title>
      )
      : (
        <>
          {participantTaskIds?.length === 0
            ? (
              <Title
                variant='h6'>
          There are no {selectedFilterOption?.value} tasks at this time.
              </Title>
            )
            : (
              <>
                {participantTaskIds?.map?.((id) => (
                  <Grid
                    item
                    md={6}
                    lg={3}
                    sx={{
                      flex      : 1,
                      marginTop : { xs: 2, sm: 0 },
                      marginX   : { xs: 0.5, sm: 0 },
                    }}
                    key={id}>
                    <TaskCard
                      id={id} refetchProfileParticipantTasks={refetchProfileParticipantTasks}
                    />
                  </Grid>
                ))}
              </>
            )}
        </>
      );

  return (
    <DefaultWrapper
      crumbs={[{ title: 'My Tasks', isActive: true }]}
      showHeader={true}
      margin={{ xs: 0, xl: '10px auto' }}>
      <Row
        sx={{
          display       : 'flex',
          flexDirection : { xs: 'column', md: 'row' },
          marginTop     : 4,
          paddingX      : '45px',
          marginX       : 'auto',
        }}>
        <Typography
          fontFamily='Montserrat' fontWeight='700' variant='h1'>
          My Tasks
        </Typography>
        <FilterMenu
          onChange={handleStatusChange}
          value={status}
          options={options}
        />
      </Row>
      <Grid
        container
        spacing={{ xs: 0, sm: 2 }}
        sx={{
          margin  : { xs: 0, xl: '10px auto' },
          padding : '15px',
        }}>
        {content}
      </Grid>
    </DefaultWrapper>
  );
};

export default MyTasks;
